import './style.css';
/* Font Awesome wordt via CDN geladen (head) om OTS/font 404-fouten te voorkomen */
import 'flowbite/dist/flowbite.js';
/* dark-mode: los in scripts.html / base-auth (één bron: assets/dark-mode.js) */

// Have the courage to follow your heart and intuition.
